import { Grid } from "@mui/material";
import { CompletionsFilter } from "services/organizationPortalClient";
import ExportCertificates from "./ExportCertificates";
import ExportCompletions from "./ExportCompletions";

type CertificatesActionsProps = {
  sortField: string;
  sortDescending: boolean;
  filter: CompletionsFilter;
};

export default function CertificatesActions({
  sortField,
  sortDescending,
  filter,
}: Readonly<CertificatesActionsProps>) {
  return (
    <Grid container columnSpacing={2} wrap="nowrap">
      <Grid item>
        <ExportCompletions
          sortField={sortField}
          sortDescending={sortDescending}
          filter={filter}
        />
      </Grid>
      <Grid item>
        <ExportCertificates
          sortField={sortField}
          sortDescending={sortDescending}
          filter={filter}
        />
      </Grid>
    </Grid>
  );
}
